import create from 'zustand';

import { DateRangeSelection } from '@builder';
import { SequenceSamplesStoreState } from './useSequenceSamplesStore.types';

const useSequenceSamplesStore = create<SequenceSamplesStoreState>((set) => ({
  selectedPill: '',
  selectedDateRange: undefined,
  data: undefined,
  isLoading: false,
  setSelectedDateRange: (selectedDateRange: DateRangeSelection) => {
    set(() => {
      return {
        selectedDateRange,
      };
    });
  },
  setData: (data: any) => {
    set(() => {
      return {
        data,
        isLoading: false,
      };
    });
  },
  setIsLoading: (isLoading: boolean) => {
    set(() => {
      return {
        isLoading,
      };
    });
  },
  setSelectedPill: (pill: any) => {
    set(() => {
      return {
        selectedPill: pill,
      };
    });
  },
}));

export default useSequenceSamplesStore;
